import api, { ApiResponse } from './api';

export interface Position {
  id: number;
  name: string;
  code?: string;
  description?: string;
  isActive: boolean;
  employeeCount: number;
}

export interface PositionCreateDto {
  name: string;
  code?: string;
  description?: string;
}

export interface PositionUpdateDto {
  name: string;
  code?: string;
  description?: string;
  isActive: boolean;
}

export interface PositionEmployee {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  departmentName: string;
  email?: string;
}

const positionService = {
  getAll: async (): Promise<ApiResponse<Position[]>> => {
    return api.get('/positions');
  },

  getById: async (id: number): Promise<ApiResponse<Position>> => {
    return api.get(`/positions/${id}`);
  },

  create: async (dto: PositionCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/positions', dto);
  },

  update: async (id: number, dto: PositionUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/positions/${id}`, dto);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/positions/${id}`);
  },

  getEmployees: async (id: number): Promise<ApiResponse<PositionEmployee[]>> => {
    return api.get(`/positions/${id}/employees`);
  },
};

export default positionService;
